type DeepCopyOfObjectType = <T>(param: T) => T

export const deepCopyOfObject: DeepCopyOfObjectType = (object) => {
  return JSON.parse(JSON.stringify(object))
}
